import React from "react";
import "./css/footer.css";
import logoFacebook from "../../resources/img/Footer/Facebook.svg";
import logoInstagram from "../../resources/img/Footer/Instagram.svg";
import up from "../../resources/img/Footer/up.svg";
import linkdin from "../../resources/img/Footer/linkdin.svg";

const Footer = () => {
  return (
    <div>
      <div className="justify-content-center align-items-center d-flex flex-column">
        <a
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <img src={up} width="40" height="41" />
        </a>
      </div>
      <footer className="d-flex flex-column justify-content-center align-items-center py-4 border-top custom-footer-hv text-center">
        <div className="color-text-footer-hv">Graphic Artist</div>

        <div className="mt-2 color-text-menor-hv px-3">
          Connect with me and let’s explore opportunities together.
        </div>

        <div className="mt-2 color-text-menor-hv">
          {"\u00A9"} 2025 Hv Helmut. All rights reserved.
        </div>

        <div className="d-flex justify-content-center align-items-center gap-3 py-3">
          <a
            href="https://www.facebook.com/hvhelmut1"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={logoFacebook}
              alt="Facebook"
              width="20"
              height="20"
              className="d-inline-block"
            />
          </a>

          <a
            href="https://www.instagram.com/hv.helmut/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={logoInstagram}
              alt="Instagram"
              width="20"
              height="20"
              className="d-inline-block"
            />
          </a>

          <a
            href="https://co.linkedin.com/in/helmut-hern%C3%A1ndez-v-2a3b07116/en"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={linkdin}
              alt="Instagram"
              width="20"
              height="20"
              className="d-inline-block"
            />
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
